import axios from 'axios';

import ENDPOINT from '../../context/EndPoint';

const GetUserPersonalBadges = async ({payload}) => {

          const formData = new FormData();

           formData.append('session',payload.user);
           formData.append('user_id',payload.user_id);
           

           try{
               const res = await axios.post(ENDPOINT+"admin-get-user-badges.php", formData,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                if(res.data){
                    return res.data
             
                }
           }
           catch(error){

return error
           }

     




}

export default GetUserPersonalBadges